// CUSTOMER PROFILE COMPONENTS DICTIONARY
// https://medium.com/@pratikpatel_60309/dynamic-importing-component-templates-with-vue-js-78d2167db1e7
export const customersProfileComponents = [
    {
        text: "People",
        icon: "people",
        name: "users",
        import: () => import("Modules/companies/customers/components/Users.vue"),
        permission: "",
    },
];
